<template>
    <div>

        <PageHeader side-class="flex-shrink-0">
            <div class="d-flex gap-3 align-items-center">
                <div>{{ item.name }}</div>
                <ButtonIcon size="sm" :disabled="!product.id" @click="showModalEditProduct()">{{ $t('edit') }}</ButtonIcon>
            </div>
            <template #side>
                <div class="d-flex gap-3">
                    <ButtonIcon icon="plus" :disabled="!product.id" @click="showModalAddProductToGroup()">{{ $t('addToGroup') }}</ButtonIcon>
                </div>
            </template>
        </PageHeader>

        <div class="mb-3">
            <div class="d-flex gap-1 align-items-center">
                <strong>GTIN:</strong>
                <b-skeleton v-if="requestProduct.getLoading()" animation="wave" width="150px" />
                <template v-else>{{ product.ean }}</template>
            </div>
            <div class="d-flex gap-1 align-items-center">
                <strong>SKU:</strong>
                <b-skeleton v-if="requestProduct.getLoading()" animation="wave" width="150px" />
                <template v-else>{{ product.sku }}</template>
            </div>
            <div class="d-flex gap-1 align-items-center">
                <strong>{{ $t('catalogPrice') }}:</strong>
                <b-skeleton v-if="requestProduct.getLoading()" animation="wave" width="150px" />
                <template v-else>{{ $format.currency(product.price) }}</template>
            </div>
        </div>

        <StatsWidgets />

        <TrafficChart />

        <SalesChart />

        <AvailabilityChart />

        <PriceChart />

        <OfferList />

        <ProductCode />

        <ProductLandingPage />

        <ModalAddProductToGroup />

    </div>
</template>



<script>
    import StatsWidgets from './StatsWidgets.vue';
    import TrafficChart from './TrafficChart.vue';
    import SalesChart from './SalesChart.vue';
    import AvailabilityChart from './AvailabilityChart.vue';
    import PriceChart from './PriceChart.vue';
    import OfferList from './OfferList.vue';
    import ProductCode from './ProductCode.vue';
    import ProductLandingPage from './ProductLandingPage.vue';
    import ModalAddProductToGroup from './ModalAddProductToGroup.vue';

    export default {
        name: 'ProductStats',
        components: {
            StatsWidgets,
            TrafficChart,
            SalesChart,
            AvailabilityChart,
            PriceChart,
            OfferList,
            ProductCode,
            ProductLandingPage,
            ModalAddProductToGroup,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                requestProduct: this.$req('producerProduct/product'),
                requestSalesStats: this.$req('producerProduct/salesStats'),
                requestClicksStats: this.$req('producerProduct/clicksStats'),
                requestImpressionsStats: this.$req('producerProduct/impressionsStats'),
                requestTrafficChart: this.$req('producerProduct/trafficChart'),
                requestSalesChart: this.$req('producerProduct/salesChart'),
                requestAvailabilityChart: this.$req('producerProduct/availabilityChart'),
                requestPriceChart: this.$req('producerProduct/priceChart'),
                requestPlugin: this.$req('plugin/producerPlugin'),
            };
        },
        computed: {
            timeRange() {
                return this.parentComponent.timeRange;
            },
            product() {
                return this.requestProduct.getData() || {};
            },
            spaceId() {
                return this.parentComponent.spaceId;
            },
        },
        watch: {
            item: {
                immediate: true,
                handler: 'fetchProduct',
            },
            spaceId: {
                immediate: true,
                handler: 'fetchPlugin',
            },
        },
        methods: {
            fetchProduct() {
                this.requestProduct.reset();
                this.requestProduct.get({ urlParams: { id: this.item.id } });
            },
            fetchPlugin() {
                this.requestPlugin.reset();
                this.requestPlugin.get(this.spaceId);
            },
            showModalEditProduct() {
                this.$root.$emit('bv::show::modal', 'modal-form-space-producer-product');
                this.$root.$emit('modal-form-space-producer-product', this.product);
            },
            showModalAddProductToGroup() {
                this.$root.$emit('bv::show::modal', 'modal-add-product-to-group');
                this.$root.$emit('modal-add-product-to-group', this.product);
            },
        },
    };
</script>
